import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IUser } from '../users.interface';
import { UserService } from '../users.service';
import { RoleLabels } from '../users.constants';
import { ICompany } from '../../../companies-page/companies/companies.interface';
import { IRole } from '../../../roles-page/roles/roles.interface';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { RolesService } from '../../../roles-page/roles/roles.service';
import { CompaniesService } from '../../../companies-page/companies/companies.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { PasswordModalComponent } from '../../../account-page/account/password-modal/password-modal.component';

let self: any;

@Component({
  selector: 'app-users-modal',
  templateUrl: './users-modal.component.html',
  styleUrls: ['./users-modal.component.css']
})
export class UsersModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  user!: IUser;
  form!: UntypedFormGroup;
  submitted = false;
  companies: ICompany[] = [];
  roles: IRole[] = [];
  isManax = false;
  isDev!: boolean;
  workers: IWorker[] = [];
  userCompanyId!: string;
  isAdmin!: boolean;
  roleLabels: any = RoleLabels;

  constructor(
    public _UserService: UserService,
    public _RolesService: RolesService,
    public _CompaniesService: CompaniesService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService,
    public _WorkersService: WorkersService,
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
    private alertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    this.isAdmin = this._AuthService.isRole('admin');
    this.isManax = this._AuthService.isManax();
    if (!this.isManax) this.userCompanyId = this._AuthService.companyId();

    if (this.isManax) {
      this._CompaniesService.getCompanies({ filters: { isDeleted: false }, sort: 'name', limit: 1000 }).subscribe((companies) => {
        this.companies = companies;
      });
    }
    this._RolesService.getRoles({ filters: { isDeleted: false }, sort: 'name', limit: 20 }).subscribe((roles) => {
      this.roles = roles.filter((el: any) => !el.isDeleted);
      if (!this.isManax) {
        if (this.isAdmin) this.roles = this.roles.filter(el => (el.name == 'worker' || el.name == 'admin' || el.name == 'supervisor'));
        else this.roles = this.roles.filter(el => el.name == 'worker');
      }

      if (this.user._id) this.getUser();
      else this.buildForm();
    });
  }

  getUser() {
    this.loading = true;
    this._UserService.getUser(this.user._id || '').subscribe((user) => {
      //console.log(user);
      this.user = user;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    let companies = (this.user.company || []).map(el => el._id);
    let roles = ((this.user.roles && this.user.roles.length > 0) ?
      this.user.roles : this.roles.filter(el => el.name == 'worker')
    ).map(el => el._id);
    let formData: any = {
      username: [this.user.username, [Validators.required]],
      roles: [roles],
      worker: [_.get(this.user, 'worker._id')],
      isActive: [this.user.isActive],
      isDeleted: [this.user.isDeleted]
    };
    if (this.user) formData.password = ['Manax2024', [Validators.required]];
    if (this.isManax) formData.company = [companies];
    this.form = this.fb.group(formData);
    this.changeOnCompanies();
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: any = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    if (!this.isManax) {
      let company: any = this._AuthService.companyId();
      if ((data.company || []).filter((el: any) => el._id == company).length == 0) {
        data.company = (data.company || []);
        data.company.push(company);
      }
    }

    if (data.company.length != 1) {
      data.worker = null;
    }

    if (this.user._id) {
      data._id = this.user._id;
      delete data.password;
      delete data.isActive;
      // data.company = _.first(data.company);
      this._UserService.updateUser(data).subscribe((user) => {
        this.dialog.close(user);
      });
    } else {
      delete data.isActive;
      // data.company = _.first(data.company);
      this._UserService.createUser(data).subscribe(
        (user) => {
          this.dialog.close(user);
        },
        (error) => {
          if (error.error.message === 'Nombre de usuario existente. Intente nuevamente con otra dirección de correo.') {
            this.alertService.error('Nombre de usuario existente. Intente nuevamente con otra dirección de correo.');
          } else if (error.error.message === 'El usuario no puede tener mas de 2 roles si contiene el rol "worker" incluido.') {
            this.alertService.error('No es posible que un usuario tenga roles de Trabajador y Administrador al mismo tiempo');
          }
          this.saving = false;
        }
      )
    }
  }

  changeOnCompanies() {
    this.workers = [];

    let company = this._AuthService.companyId();
    if (this.user._id) company = _.get(this.user, 'company[0]._id', this.userCompanyId);

    if (_.get(this.f['company'], 'value.length', 0) == 1) {
      company = this.f['company'].value[0];
    }
    this._WorkersService.getWorkers({
      filters: { isDeleted: false },
      company: company,
      sort: 'firstname lastname',
      skip: 0,
      limit: 1000
    }).subscribe((workers) => {
      this.workers = workers;
    });
  }

  changePassword() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '500px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(PasswordModalComponent, config);
    self.dialogRef.componentInstance.resetPassword = true;
    self.dialogRef.componentInstance.user = this.user;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }
}